import { AppHelper } from "../appHelper";
import { MonacoEditor } from "../core/components/monacoEditor"
import { AppBaseProps, CommonApp, Entity, Metadata } from "../core/components/commonApp";
import { General } from "../../siteManagement/general";
import { Helper } from "../core/util/helper";
import { ComponentHelper } from "../core/util/componentHelper";
import { DropDownList } from "../core/components/dropDownList";
import { IsSearchField } from "../core/components/isSearchField";
import { Dialog, DialogProps } from "../core/components/dialog";
import { Config } from "../core/config/config";
import { ReportDefinition, TargetEntityType } from "./reportMetaData";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { NotificationHelper } from "../core/util/notificationHelper";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import React from "react";
import ReactDOM from "react-dom";

interface FileNameAndDocumentTitleDefaultSqlProps extends BaseComponentProps {
    value: string;
    entity: ReportDefinition
}

export default class FileNameAndDocumentTitleDefaultSql extends React.Component<FileNameAndDocumentTitleDefaultSqlProps, any>{

    private metaData: Metadata = {
        tabs: [
            {
                title: "Skurr",
                component: "renderEditor()",
                visible: true,
                iconName: "poo"
            }
        ],
        menuDataSource: [
            {
                type: "save"
            },
            {
                text: Helper.getTranslation("WebCRM.Email.ExecuteSQL"),
                onClick: "executeSQL()",
                icon: "caret-circle-right",
                floating: true,
                floatingColor: "#00c853",
                show: "showExecuteButton"
            }
        ],
        additional: {
            objects: []
        }
    }

    constructor(props) {
        super(props);
    }

    private onChange = (value: string) => {
        this.props.onChange(this.props.field, value)
    }

    private editSQL = () => {
        const props: EditorProps = {
            context: {},
            dataSources: {},
            entity: {
                TargetEntityType: this.props.entity.TargetEntityType,
                SQL: this.props.value,
                IsNew: false,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                IndividualFields: {

                },
            },
            disabled: this.props.disabled,
            isWindow: false,
            metadata: this.metaData,
            title: null,
            onSave: this.onChange
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.show(() => {
            sheet.mountContent(Editor, props)
        })
        sheet.setTitle(Helper.getTranslation("WebCRM.Email.EditSQL"));
    }

    private renderButton = (title: string, onClick: () => void) => {
        return (
            <div
                onClick={onClick}
                style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px", width: "fit-content", borderRadius: "var(--border-radius)", border: "1px solid var(--secondary-color)", color: "white", backgroundColor: "var(--primary-color)", cursor: "pointer", marginRight: "5px" }} >
                {title}
            </div>
        )
    }

    render() {
        return (
            <div style={{ display: "flex" }} >
                {this.renderButton(Helper.getTranslation(this.props.disabled ? "WebCRM.Email.ViewSQL" : "WebCRM.Email.EditSQL"), this.editSQL)}
                {Helper.isNullOrEmpty(this.props.value) || this.props.disabled ? null : this.renderButton(Helper.getTranslation("WebCRM.Email.RemoveSQL"), () => { this.onChange("") })}
            </div>
        );
    }
}

interface EditorProps extends AppBaseProps {
    entity: SQLEntity;
    onSave: (sql: string) => void;
    disabled: boolean;
};

interface SQLEntity extends Entity {
    SQL: string;
    TargetEntityType: TargetEntityType;
}

class Editor extends React.Component<EditorProps, {sql: string}>{

    private common = new AppHelper();
    private editor: SQLEditor;
    showExecuteButton: boolean; 

    constructor(props: EditorProps) {
        super(props);
        this.showExecuteButton = !Helper.isNullOrEmpty(props.entity.SQL)

        this.common.enableHooks = true;
        this.common.init(this);

        this.state = {
            sql: props.entity.SQL
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private onChange = (sql: string) => {
        this.showExecuteButton = !Helper.isNullOrEmpty(sql)
        this.setState({ sql: sql })
    }

    renderEditor = () => {
        return <SQLEditor targetEntityType={this.props.entity.TargetEntityType} SQL={this.state.sql} onChange={this.onChange} ref={(ref) => { this.editor = ref }} disabled={this.props.disabled} />
    }

    save = () => {
        this.props.onSave(this.state.sql);
        this.common.sheetWrapper.hide();
    } 

    executeSQL = () => {
        this.editor.executeSQL();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface SQLEditorProps {
    SQL: string;
    targetEntityType: TargetEntityType;
    onChange: (sql: string) => void;
    disabled: boolean;
}

class SQLEditor extends React.Component<SQLEditorProps, { sql: string, params: Paramaters }>{
    constructor(props: any) {
        super(props);
        this.state = {
            sql: props.SQL,
            params: null
        }
    }

    executeSQL = async () => {
        let params = this.state.params;
        if (!params) {
            params = {
                languageCode: Config.user.languageCode,
                pwUserName: Config.user.userName,
                targetIsGuid: null
            }
        }

        const result = await HTTPService.post<JsonResultClass>("ReportMetaData/TestFileNameAndTitle", {
            TargetIsGuid: params.targetIsGuid,
            PwUserName: params.pwUserName,
            LanguageCode: params.languageCode,
            SQL: this.state.sql,
            TargetEntityType: this.props.targetEntityType
        });


        if (result.Code == 1) {
            NotificationHelper.showErrorMessage(result.Message)
            return;
        } 

        let { FileName, OptionalDocumentTitle } = result.Data;
        OptionalDocumentTitle = Helper.isNullOrEmpty(OptionalDocumentTitle) ? FileName : OptionalDocumentTitle;

        const targetElement = $("<div>");
        $("body").append(targetElement);

        const remove_dialog = () => {
            ReactDOM.unmountComponentAtNode(targetElement[0]);
            targetElement[0].remove();
        }

        const dialogProps: DialogProps = {
            title: "Result",
            actions: [
                {
                    label: Config.translations.ok,
                    action: () => {

                    },
                    primary: true
                }
            ],
            afterClose: remove_dialog,
            width: 500
        };
        ReactDOM.render(
            <Dialog {...dialogProps} open={true}>
                <div style={{ display: "grid", gridTemplateRows: "minmax(30px, auto) minmax(30px, auto)", gridTemplateColumns: "2fr 3fr", gridGap: "3px" }} >
                    <span style={{ gridRow: "1/2", gridColumn: "1/2" }}>
                        {Helper.getTranslation("WebSMS.QRReports.FileName")}
                    </span>
                    <span style={{ gridRow: "1/2", gridColumn: "2/3" }}>
                        {FileName }
                    </span>
                    <span style={{ gridRow: "2/3", gridColumn: "1/2" }}>
                        {Helper.getTranslation("Dokument.DocumentTitle")}
                    </span>
                    <span style={{ gridRow: "2/3", gridColumn: "2/3" }}>
                        {OptionalDocumentTitle}
                    </span>
                </div>
            </Dialog >, targetElement[0]);

    }

    onChange = (params: Paramaters) => {
        this.setState({ params: params })
    }

    private checkForParams = (sql: string) => {
        const regex = /\W@[a-zA-Z]+/;

        let tmp: string = JSON.parse(JSON.stringify(sql))
        let parameters: Array<string> = [];
        let match: RegExpExecArray;
        let param: string;

        do {
            match = regex.exec(tmp);

            if (match) {
                param = match[0].trim();
                parameters.push(param)
                tmp = tmp.replace(param, "~~~");
            }
        } while (match);
        const allowedParameters = ["@targetIsGuid", "@pwUserName", "@languageCode"];
        const filter = (value, index, array) => {
            return array.indexOf(value) === index && allowedParameters.indexOf(value) === -1;
        }
        const warning = (value) => {
            NotificationHelper.showWarningMessage(`${Helper.getTranslation("WebCRM.Email.UnsupportedParametersDetected")}: ${value}`)
        }
        parameters.filter(filter).forEach(warning)
    }

    private setSQL = (sql) => {
        this.setState({ sql: sql }, () => {
            this.checkForParams(sql);
            this.props.onChange(sql);
        });
    }

    render() {
        return (
            <div style={{ display: "grid", gridTemplateRows: "1fr", gridTemplateColumns: "4fr 1fr", height: "100%" }} >
                <div style={{ gridRow: "1/2", gridColumn: "1/2" }} >
                    <MonacoEditor language="sql" code={this.state.sql} onKeyPress={this.setSQL} readOnly={this.props.disabled} />
                </div>
                <div style={{ gridRow: "1/2", gridColumn: "2/3" }}>
                    <ParameterListContainer targetEntityType={this.props.targetEntityType} onChange={this.onChange} />
                </div>
            </div>
        );
    }
}

interface ParameterListContainerState extends Paramaters {
    targetId: string;
}


class ParameterListContainer extends React.Component<{ targetEntityType: TargetEntityType, onChange: (params: Paramaters) => void }, ParameterListContainerState>{
    private factory = ComponentHelper.createFactory();

    constructor(props) {
        super(props)

        this.state = {
            languageCode: Config.user.languageCode,
            pwUserName: Config.user.userName,
            targetId: null,
            targetIsGuid: null
        }
    }

    private afterUpdate = () => {
        const params: Paramaters = {
            languageCode: this.state.languageCode,
            pwUserName: this.state.pwUserName,
            targetIsGuid: this.state.targetIsGuid
        }
        this.props.onChange(params)
    }

    private renderComponent = (translationKey: string, parameter: string, component: JSX.Element) => {
        return (
            <>
                <div style={{ margin: "7px" }} >
                    <div style={{ padding: "2px 0" }} >
                        {Helper.getTranslation(translationKey)} (@{parameter})
                    </div>
                    {component}
                </div>
            </>
        );
    }

    private renderLanguageDropDown = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.value = this.state.languageCode;
        props.onChange = (_, value) => {
            this.setState({ languageCode: value }, this.afterUpdate)
        };
        props.field.dataSourceUrl = "ReportMetaData/GetLanguages";
        props.field.dataValueField = "Key";
        props.field.dataTextField = "Value";
        props.field.optionLabel = "";

        const dropDown = <DropDownList {...props} />
        return this.renderComponent("Sprachen.Sprache", "languageCode", dropDown);
    }

    private renderUserSearchField = () => {
        const props = this.factory.getDefaultSearchFieldProps();
        props.onChange = (_, value) => {
            this.setState({ pwUserName: value }, this.afterUpdate)
        }
        props.value = this.state.pwUserName
        props.field.autocompleteEnabled = true;
        props.field.autocompleteTemplate = "<table cellspacing='0' style='table-layout:fixed; width:350px'><colgroup><col style='width: 150px' /><col style='width: 150px' /></colgroup><tr><td style='vertical-align:top; word-wrap: break-word;'>${data.Name}</td><td style='vertical-align:top'>${data.Name2}</td></tr></table>";
        props.field.autocompleteUrl = "UserLookup/Find";
        props.field.autocompleteDataTextField = "Name";
        props.field.searchButtonEnabled = true;
        props.field.searchWindowTitle = Helper.getTranslation("Standard.Benutzersuche");
        props.field.searchWindowUrl = "DynamicSearch/Window/User";
        props.field.readOnlyTextField = true;


        const searchField = <IsSearchField {...props} />
        return this.renderComponent("Server.User", "pwUserName", searchField);
    }

    private renderTargetSearch = () => {
        let url; 
        let getDisplayKey = (dataItem) => {
            return Helper.getAttributeSavely(dataItem, "isguid");
        }
        switch (this.props.targetEntityType) {
            case TargetEntityType.Address:
                url = encodeURI("DynamicSearch/Window/Address?fullObject=true");
                break;
            case TargetEntityType.Assignment:
                url = encodeURI("DynamicSearch/Window/Assignment?fullObject=true");
                break;
            case TargetEntityType.CustomReport:
                url = encodeURI("DynamicSearch/Window/crReport?fullObject=true");
                getDisplayKey = (dataItem) => {
                    return Helper.getAttributeSavely(dataItem, "id");
                }
                break;
            case TargetEntityType.Machine:
                url = encodeURI("DynamicSearch/Window/Machine?fullObject=true");
                break;
            case TargetEntityType.Material:
                url = encodeURI("DynamicSearch/Window/Parts?fullObject=true");
                break;
            case TargetEntityType.Project:
                url = encodeURI("DynamicSearch/Window/Project?fullObject=true");
                break;
            case TargetEntityType.Resource:
                url = encodeURI("DynamicSearch/Window/Resource?fullObject=true");
                break;
            case TargetEntityType.ServiceReport:
                url = encodeURI("DynamicSearch/Window/Servicereport?fullObject=true");
                break;
            case TargetEntityType.Ticket:
                url = encodeURI("DynamicSearch/Window/Procedure?fullObject=true");
                break;
        }
        

        const props = this.factory.getDefaultSearchFieldProps();
        
        props.handleIsSearchFieldFullObjectModel = async (_, dataItem) => {
            const key = getDisplayKey(dataItem);
            console.log(key)
            //const isGuid = await HTTPService.get<string>(encodeURI(`ReportMetaData/GetIsGuid?id=${key}&targetEntityType=${this.props.targetEntityType}`))
            this.setState({ targetId: key, targetIsGuid: key }, this.afterUpdate)
        }
        console.log(this.state)
        props.field.searchWindowUrl = url;
        props.value = this.state.targetId;
        props.field.searchButtonEnabled = true;
        props.field.readOnlyTextField = true;


        const searchField = <IsSearchField {...props} />
        return this.renderComponent("WebSMS.ReportMetadata.TestObject", "targetIsGuid", searchField);
    }

    render() {
        return (
            <div>
                {this.renderTargetSearch()}
                {this.renderUserSearchField()}
                {this.renderLanguageDropDown()}
            </div>
        );
    }
}

interface Paramaters {
    targetIsGuid: string;
    pwUserName: string;
    languageCode: string;
}